import React, { createContext, useEffect, useState } from 'react';

export const ScrollContext = createContext('');

const isWindowAvailable = typeof window !== 'undefined';

const getPosition = () => (isWindowAvailable ? window.pageYOffset : undefined);

const useWindowScrollPosition = () => {
  const [scrollPosition, setScrollPosition] = useState(getPosition());

  useEffect(() => {
    if (!isWindowAvailable) {
      return false;
    }

    const handleScroll = () => {
      setScrollPosition(getPosition());
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return scrollPosition;
};
export default ({ children }) => {
  const y = useWindowScrollPosition();
  return <ScrollContext.Provider value={y}>{children}</ScrollContext.Provider>;
};
